import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { getRoomBlocks } from "@/core/components/sites/site/room-blocks/roomBlocksQueryOptions";

const roomBlocksSearchSchema = z.object({
	page: z.number().catch(1),
	pageSize: z.number().catch(10),
	search: z.string().catch(""),
	sortBy: z
		.enum([
			"id",
			"name",
			"releasedAt",
			"roomBlockCode",
			"startDate",
			"endDate",
			"type",
		])
		.catch("startDate"),
	orderBy: z.enum(["asc", "desc"]).catch("asc"),
});
export const Route = createFileRoute(
	"/_layout/dashboard/sites/$siteId/room-blocks/",
)({
	validateSearch: (search) => roomBlocksSearchSchema.parse(search),
	beforeLoad: ({ context: { auth } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (
			auth.user?.role === Role["Front-Desk"] ||
			auth.user?.role === Role["Blogger"]
		) {
			throw redirect({
				to: "/dashboard",
			});
		}
	},
	loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
		const roomBlocks = queryClient.ensureQueryData(
			getRoomBlocks(siteId, auth.token!),
		);
		return {
			roomBlocks,
		};
	},
	pendingComponent: LoadingList,
	errorComponent: ErrorComponent,
});
